import React from 'react';
import sectionStyles from '../../StructuredSections.module.scss';
import { ProcessedSection } from '../../sectionProcessing';
import { PIMCORE_CONTENT_BASE_URL } from '../../../../../utils/Pimcore';

export function renderVideoBlockContent(section: ProcessedSection): React.ReactNode {
    const block = section.videoBlock;
    if (!block) {
        return null;
    }

    if (block.video.kind === 'internal') {
        const src = `${PIMCORE_CONTENT_BASE_URL}${block.video.asset.fullpath}`;
        return (
            <div className={sectionStyles.videoBlock}>
                <video className={sectionStyles.videoElement} controls aria-label={block.ariaLabel}>
                    <source src={src} type={block.video.asset.mimeType} />
                    Your browser does not support the video tag.
                </video>
            </div>
        );
    }

    return (
        <div className={sectionStyles.videoBlock}>
            <div className={sectionStyles.iframeWrapper}>
                {/* we set aria-label instead of title to avoid tooltip over video */}
                {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                <iframe
                    src={block.video.embedUrl}
                    aria-label={block.ariaLabel}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                />
            </div>
        </div>
    );
}
